import { objToArr } from "../../utils/utils";

const FileSelection = {
  opts: {},
  selection: {},
  ctrlto: null,
  add: function (meta) {

    console.log('fs meta', meta);
    this.selection[meta.id] = meta;

    this.prepControls();
  },
  remove: function (meta) {
    if (this.selection[meta.id])
      delete this.selection[meta.id];

    this.prepControls();
  },
  reset: function (selectionOnly) {
    var selectionOnly = selectionOnly || false;

    this.selection = {};
    this.prepControls();

    if (!selectionOnly)
      this.opts = {};
  },
  prepControls: function () {

    if (this.ctrlto) {
      clearTimeout(this.ctrlto);
      this.ctrlto = null;
    }
  },
  getAsParams: function () {
    var ret = { }, fileids = [], folderids = [], n, item;
    for (n in this.selection) {
      item = this.selection[n];
      if (item.isfolder) {
        if (folderids == undefined)
          folderids = [];
        folderids.push(item.folderid);
      }
      else {
        if (fileids == undefined)
          fileids = [];
        fileids.push(item.fileid);
      }
    }

    if (fileids.length)
      ret.fileids = fileids.join(',');
    if (folderids.length)
      ret.folderids = folderids.join(',');

    return ret;
  },
  filter: function (list, filter, useMatch, all) {
    if (all == undefined) all = true;
    var r = [], n = 0, ret, match = useMatch || false, matchN = all ? obLength(filter) : 1, cMatch;

    for ( ; n < list.length; ++n) {
      ret = true;
      cMatch = 0;
      for (var k in filter) {

        if (list[n][k] && ((!match && list[n][k] == filter[k]) || (match && list[n][k].toLowerCase().match(filter[k].toLowerCase())) ))
          cMatch++;
      }

      if (cMatch >= matchN)
        r.push(list[n]);
    }

    return r;
  },
  getSelectionInfo: function () {
    var sel = objToArr(this.selection);
    sel.sort(function (a, b) {
      return b.isfolder - a.isfolder;
    });

    return sel;
  },
  getAsArrays: function () {
    var ret = {}, n, item;
    for ( n in this.selection ) {
      item = this.selection[n];
      if (item.isfolder) {
        if (ret.folderids == undefined)
          ret.folderids = [];
        ret.folderids.push(item.folderid);
      } else {
        if (ret.fileids == undefined)
          ret.fileids = [];
        ret.fileids.push(item.fileid);
      }
    }
    return ret;
  },
  hasId: function (id) {
    return (this.selection[id] != undefined);
  },
  getAsArray: function () {
    var ret = {}, n;
    for ( n in this.selection ) {
      var item 	= this.selection[n],
        name 	= this.dataKey(item, true),
        value 	= this.dataValue(item);
      if (ret[name] == undefined)
        ret[name] = [];
      ret[name].push(value);
    }
    return ret;
  },
  dataKey: function (data, multi) {
    return (data.isfolder ? 'folderid' : 'fileid') + (multi ? 's' : '');
  },
  dataValue: function (data) {
    return data.isfolder ? data.folderid : data.fileid;
  },
  itemData: function (data) {
    if (data.isfolder)
      return { folderids: [data.folderid] };
    else
      return { fileids: [data.fileid] };
  }
}

window.fs = FileSelection;

export default FileSelection;